import ApiClient from './apiClient';

export const SELLER_TIERS = ['Trusted', 'Normal', 'Low', 'Excluded'];

export const SELLER_TIER_COLORS = {
  Trusted: 'success',
  Normal: 'grey',
  Low: 'warning',
  Excluded: 'error',
};

export class SellersService {
  /**
   * @param {{ searchText?: string, sortOrderField?: string, sortDirection?: string, itemsPerPage?: number, itemsToSkip?: number }} search
   * @param {{ tier?: string, ratedOnly?: boolean }} filters
   * @returns {Promise<{ items: Array<{ id: number, marketplaceId: number, userID: string, eBayStoreName: string, eBayStoreURL: string,
   *   feedbackScore: number, positiveFeedbackPercent: number, tier: string, weight: number, notes: string,
   *   updatedBy: string, updatedDateTime: string }>, totalItemCount: number }>}
   */
  async getSellers(search, { tier, ratedOnly = true } = {}) {
    const response = await ApiClient.get('api/sellers', {
      params: { ...search, tier: tier || undefined, ratedOnly },
    });
    return response.data;
  }

  async getSeller(id) {
    const response = await ApiClient.get(`api/sellers/${id}`);
    return response.data;
  }

  async updateSellerSettings(id, { tier, weight, notes }) {
    const response = await ApiClient.put(`api/sellers/${id}/settings`, { tier, weight, notes });
    this._clearCaches();
    return response.data;
  }

  _clearCaches() {
    ApiClient.clearCache('api/sellers');
    ApiClient.clearCache('api/listings');
    ApiClient.clearCache('api/snapshots');
  }

  /**
   * 
   * @returns {Promise<{
   *  count: number,
   *  items: Array<{
    *  id: number,
    *  marketplaceId: number,
    *  userID: string,
    *  preferredSeller: boolean,
    *  feedbackScore: number,
    *  positiveFeedbackPercent: number,
    *  eBayStoreName: string,
    *  eBayStoreURL: string,
    *  excludeSellerListings: true
   *  }>
   * }>}
   */
  async getExcludedSellers() {
    const response = await ApiClient.getWithCache('api/sellers/excludedsellers');
    return response.data;
  }

  async includeSeller(id) {
    const response = await ApiClient.put(`api/sellers/include/${id}`);
    this._clearCaches();
    return response.data;
  }

  async excludeSeller(id) {
    const response = await ApiClient.put(`api/sellers/exclude/${id}`);
    this._clearCaches();
    return response.data;
  }
}
